import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import React from "react";
import { SDUIButtonRenderer } from "../Button/SDUIButtonRenderer";
import { SDUIRichTextRenderer } from "../RichText/SDUIRichTextRenderer";
import { siteBannerWrapper } from "./__internal__/styles/SDUISiteBannerRenderer.css";
import { IButtonElement } from "@faire/web-api--source/indigofair/data/IButtonElement";
export var SDUISiteBannerRenderer = function(param) {
    var component = param.component, loggingData = param.loggingData;
    var siteBannerComponent = component.site_banner_component;
    if (!siteBannerComponent) {
        return null;
    }
    var description = siteBannerComponent.description;
    var mobileValue = description === null || description === void 0 ? void 0 : description.mobile_and_above;
    var _description_tablet_and_above;
    var tabletValue = (_description_tablet_and_above = description === null || description === void 0 ? void 0 : description.tablet_and_above) !== null && _description_tablet_and_above !== void 0 ? _description_tablet_and_above : mobileValue;
    var _description_desktop_and_above;
    var desktopAndAboveValue = (_description_desktop_and_above = description === null || description === void 0 ? void 0 : description.desktop_and_above) !== null && _description_desktop_and_above !== void 0 ? _description_desktop_and_above : tabletValue;
    var _siteBannerComponent_button_variant;
    return /*#__PURE__*/ _jsx("div", {
        className: siteBannerWrapper,
        style: {
            backgroundColor: Decorative.tint.neutral
        },
        "data-test-id": "site-banner-renderer",
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                    noJS: true,
                    mobile: /*#__PURE__*/ _jsx(SDUIRichTextRenderer, {
                        richTextElement: mobileValue
                    }),
                    tablet: /*#__PURE__*/ _jsx(SDUIRichTextRenderer, {
                        richTextElement: tabletValue
                    }),
                    desktopAndAbove: /*#__PURE__*/ _jsx(SDUIRichTextRenderer, {
                        richTextElement: desktopAndAboveValue
                    })
                }),
                " ",
                siteBannerComponent.button ? /*#__PURE__*/ _jsx(SDUIButtonRenderer, {
                    buttonElement: _object_spread_props(_object_spread({}, siteBannerComponent.button), {
                        variant: (_siteBannerComponent_button_variant = siteBannerComponent.button.variant) !== null && _siteBannerComponent_button_variant !== void 0 ? _siteBannerComponent_button_variant : IButtonElement.ButtonVariant.TERTIARY
                    }),
                    loggingData: loggingData
                }) : null
            ]
        })
    });
};
